module.exports = __webpack_public_path__ + "img/12.9fa26c5a.png";